import { Page, withModel } from "@adobe/aem-react-editable-components";
import React from "react";
import AleloContextProvider from "./context/aleloContext";
import { ThemeProvider } from "@rango/core/Provider";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import "./components/import-components";

import "../node_modules/@rango/assets/src/fonts/fonts.css";

document.body.setAttribute("data-theme", "default-light");

// This component is the application entry point
class App extends Page {
	render() {
		const history = createBrowserHistory();
		return (
			<AleloContextProvider>
				<ThemeProvider theme='light'>
					<Router history={history}>
						<div>
							{this.childComponents}
							{this.childPages}
						</div>						
					</Router>
				</ThemeProvider>
			</AleloContextProvider>
		);
	}
}

export default withModel(App);
